import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auction-details-hero-skeleton',
  templateUrl: './auction-details-hero-skeleton.component.html',
  styleUrls: ['./auction-details-hero-skeleton.component.scss']
})
export class AuctionDetailsHeroSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
